import { getSessionStorage } from "../../../../utils/StorageUtil"
import { USER_SO_KEY } from "../../../../utils/accountUtils"

export default (props: any) => {
  const user = getSessionStorage(USER_SO_KEY)
  const userID = user ? `${user.firstName} ${user.lastName}` : ''
  return {
    company: props.companyName,
    userID: userID,
    mileage: '',
    title: '',
    description: ''
  }
}